import React, { useRef } from 'react';
import Toggle from './Toggle.jsx';
import MergeTagChips from '../marketing/MergeTagChips.jsx';

const field = 'w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm text-white placeholder:text-white/35 focus:border-civix-purple/60 focus:outline-hidden';

/**
 * One notification line: title + help text + switch, with its editor revealed when on.
 * @param {{title: string, help: string, on: boolean, onToggle: (v: boolean) => void, disabledReason?: string, testId: string, children?: React.ReactNode}} props
 */
export function NotificationRow({ title, help, on, onToggle, disabledReason, testId, children }) {
  return (
    <div className="border-t border-white/10 py-4" data-testid={`notif-${testId}`}>
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="text-sm font-medium text-white">{title}</div>
          <div className="text-xs text-white/50">{disabledReason || help}</div>
        </div>
        <Toggle checked={on} onChange={onToggle} label={title} disabled={!!disabledReason} testId={`toggle-${testId}`} />
      </div>
      {on && children && <div className="mt-3 space-y-2">{children}</div>}
    </div>
  );
}

/** Message editor with the "available words" chips. */
export function MessageBox({ value, onChange, rows = 3, testId }) {
  const ref = useRef(null);
  return (
    <>
      <textarea ref={ref} value={value} onChange={(e) => onChange(e.target.value)} rows={rows} className={`${field} font-mono`} data-testid={testId} />
      <MergeTagChips value={value} onChange={onChange} textareaRef={ref} max={5000} testId={`${testId}-chips`} />
      <p className="text-[11px] text-white/40">{'{date}'} and {'{time}'} are filled in with the event's date and time.</p>
    </>
  );
}

export { field as inputClass };
